import React, { useState, useEffect, lazy, Suspense } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import App from "./App";

import { Helmet } from "react-helmet";
import Landing from "./components/Landing";
import "react-toastify/dist/ReactToastify.css";

import "./assets/fonts/font-awesome.min.css";
import "./assets/default/globalMessageStyles.css";
import LoadingSpinner from "./components/LoadingSpinner";

// import component to load
import SSOLogin from "./components/SSOLogin";
import SignOutPageSSO from "./components/SignOutPageSSO";
import ErrorPage from "./components/ErrorPage";
import GuardedRoute from "./utils/RouteGuard";
import AddressVerfication from "./components/AddressVerfication";
import MaintenancePage from "../src/MaintenancePage/index";
import HomeSSORedirectDynamic from "./components/SSOLogin/HomeSSORedirect";
import ResetPassword from "./components/ResetPassword";
const PersonalizeMessageOptionComp  = lazy(() => import("./components/PersonalizeMessageOption"));

const SearchResults = lazy(() => import("./components/SearchResults"));
const SessionLogout = lazy(() => import("./components/SessionLogout"));
const ItemDetailComp = lazy(() => import("./components/ItemDetails"));
const MarketingMaterial = lazy(() => import("./components/MarketingMaterial"));
const ECheckOut = lazy(() => import("./components/ECheckOut"));
const UnsubscribeEmail = lazy(() => import("./components/UnsubscribeEmail"));
const CustomizeTemplatesComp = lazy(() =>
  import("./components/CustomizeTemplates")
);
const CustomizeTestTemplatesComp = lazy(() =>
  import("./components/CustomizeTestTemplates")
);
const TemplateDetail = lazy(() => import("./components/TemplateDetail"));
const EmailDetail = lazy(() => import("./components/EmailDetail"));
const CheckOutComp = lazy(() => import("./components/CheckOut"));
const OrderDetailComp = lazy(() => import("./components/OrderDetail"));
const ConfirmPassword = lazy(() => import("./components/ConfirmPassword"));
const ConfirmEmail = lazy(() => import("./components/ConfirmEmail"));
const TemplateSetup = lazy(() => import("./components/TemplateSetup"));
const ManageStateShipWith = lazy(() =>
  import("./components/ManageStateShipWith")
);

const Cart = lazy(() => import("./components/Cart"));

const PasswordChangeSuccessful = lazy(() =>
  import("./components/PasswordChangeSuccessful")
);
const CreateCollectionComp = lazy(() =>
  import("./components/Collections/CreateCollection")
);
const ModifyCollectionComp = lazy(() =>
  import("./components/Collections/ModifyCollection")
);
const CollectionComp = lazy(() => import("./components/Collections"));
const UserProfile = lazy(() => import("./components/UserProfile"));
const SalesTeam = lazy(() => import("./components/SalesTeam"));
const AttributeSalesTeam = lazy(() =>
  import("./components/AttributeSalesTeam")
);
const OrderSearch = lazy(() => import("./components/OrderSearch"));
const ShippingTypeComp = lazy(() => import("./components/shippingType"));
const AllUserRoles = lazy(() => import("./components/UserRole/AllUserRoles"));
const UserDetail = lazy(() => import("./components/UserRole/UserRoleDetail"));
const UserRoleCreate = lazy(() =>
  import("./components/UserRole/CreateUserRole")
);
const EmailManagement = lazy(() => import("./components/EmailManagement"));
const Account = lazy(() => import("./components/Account"));
const Notifications = lazy(() => import("./components/Notifications"));
const ProductDisplay = lazy(() => import("./components/ProductDisplay"));
const UserSearch = lazy(() => import("./components/UserSearch"));
const CreateUser = lazy(() => import("./components/CreateUser"));
const ShipToHcpComp = lazy(() => import("./components/ShipMethods/shipToHcp"));
const HcpCustomComp = lazy(() => import("./components/ShipMethods/HcpCustomFeature"));
const ShipToDistributionComp = lazy(() =>
  import("./components/ShipMethods/ShipToDistribution")
);
const OrderDetailInfoComp = lazy(() => import("./components/OrderDetailComp"));
const Support = lazy(() => import("./components/Support"));
const ValidForUse = lazy(() => import("./components/ValidForUse"));
const ViewAllTemplates = lazy(() => import("./components/ViewAllTemplates"));

const SiteAdministration = lazy(() =>
  import("./components/SiteAdministration")
);

const AddNewMessage = lazy(() =>
  import("./components/AddNewMessage")
);
// const CustomizeTemplate = lazy(() => import("./components/CustomizeTemplates"));
// const CustomizeTemplate = lazy(() => import("./components/CustomizeTemplates"));

const AddressBook = lazy(() => import("./components/AddressBook"));
const AddressBookCreateEditComp = lazy(() =>
  import("./components/AddressBook/AddressBookCreateEdit")
);

const ShippingMethodsAssignment = lazy(() =>
  import("./components/ShippingMethodsAssignment")
);
const ErrorDetail = lazy(() => import("./components/ErrorDetail"));

const MainApp = () => {
  const location = useLocation();

  const [logo, setLogo] = useState("");
  const [title, setTitle] = useState("");
  const [showTitle, setShowTitle] = useState("");
  const companyNumber = useSelector((state) => state.login.companyNumber);
  const pageTitle = useSelector((state) => {
    let item = state.support.adminData?.headerLinks?.pageTitle;
    return item?.clientSpecificLabel || item?.defaultLabel;
  });
  const showField = useSelector((state) => {
    let item = state.support.adminData?.headerLinks?.pageTitle;
    return item?.fieldVisible == "true"
      ? true
      : item?.fieldVisible == "false"
      ? false
      : item?.fieldVisible == "NA"
      ? item?.defaultFieldVisible == "true"
        ? true
        : false
      : true;
  });

  //Maintenance Page
  // eslint-disable-next-line no-unused-vars
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.href);

    const locationArr = location.pathname?.split("/") || [];
    let id = locationArr.pop();
    id = typeof id === "string" ? id.replace(/^us+/i, "") : id;

    console.log("locationArr, id :>> ", locationArr, id);
    // added condition for preselect direct link
    if (locationArr.includes("preselect")) {
      sessionStorage.removeItem("isOrderDetailDirectLink");
      sessionStorage.removeItem("orderNumber");

      sessionStorage.setItem("preselect", true);
      sessionStorage.setItem("hcpid", id);
    }

    // added condition for direct link to order
    if (locationArr.includes("orderDetailData")) {
      sessionStorage.removeItem("preselect");
      sessionStorage.removeItem("hcpid");

      sessionStorage.setItem("isOrderDetailDirectLink", true);
      sessionStorage.setItem("orderNumber", id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let compNum;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    compNum = localStorage.getItem("companyNumber");
    let currentCompanyNumber = companyNumber || compNum || "";
    console.log("currentCompanyNumber :>> ", currentCompanyNumber);
    let currentTitle = pageTitle;
    // Set companyNumber to "0831" for localhost
    if (window.location.hostname === "localhost") {
      currentCompanyNumber = "1286";
      currentTitle = "DEMO";
    }

    if (currentCompanyNumber) {
      import(`./../src/assets/${currentCompanyNumber}/logos/logoiconclient.ico`)
        .then((favicon) => {
          setLogo(favicon.default);
        })
        .catch(() => {
          // Handle errors if the company number doesn't exist or the favicon is not found
          setLogo(""); // Default to ""
        });
    } else {
      // Handle the case when the company number is not available yet
      setLogo(""); // Default to ""
    }

    if (pageTitle) setTitle(currentTitle);
    setShowTitle(showField);
  }, [companyNumber, pageTitle, showField]);

  useEffect(() => {
    document.title = showField ? title : "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTitle, showField]);

  const { userPrivilege = [] } = useSelector((state) => state.login);

  // Splash page
  const [showSplashPage, setShowSplashPage] = useState(false);
  useEffect(() => {
    const lowerUrl = window.location.href.toLowerCase();
    if (
      !lowerUrl.includes("localhost") &&
      !lowerUrl.includes("dev") &&
      !lowerUrl.includes("qa") &&
      !lowerUrl.includes("uat")
    ) {
      setShowSplashPage(false);
    } else {
      setShowSplashPage(false);
    }
  }, []);

  //App Loader
  useEffect(() => {
    const loaderElement = document.querySelector(".loading-box");
    if (loaderElement) {
      loaderElement.style.display = "none";
    }
  }, []);

  return (
    <>
      <Helmet>
        {showTitle ? <title>{title}</title> : ""}
        <link rel="icon" href={logo} />
      </Helmet>
      {companyNumber === "1110" ? (
        <Helmet>
          <script
            type="text/javascript"
            src={`https://script.bi-instatag.com?ref=+encodeURIComponent(${window.location.href})`}
          />
        </Helmet>
      ) : null}
      <Routes>
        <Route
          path="/"
          exact
          element={
            showSplashPage ? <MaintenancePage /> : <HomeSSORedirectDynamic />
          }
        />
        <Route
          exact
          path="/order/hcps/preselect/:hcpid"
          element={
            showSplashPage ? <MaintenancePage /> : <HomeSSORedirectDynamic />
          }
        />

        <Route
          path="/login"
          exact
          element={showSplashPage ? <MaintenancePage /> : <App />}
        />
        <Route
          path="/ssologin.action"
          exact
          element={showSplashPage ? <MaintenancePage /> : <SSOLogin />}
        />

        <Route path="/ssosignout" exact element={<SignOutPageSSO />} />
        <Route path="/login-error" exact element={<ErrorPage />} />
        <Route
          exact
          path="/address-verified"
          element={<AddressVerfication />}
        />
        <Route exact path="/reset-password" element={<ResetPassword />} />
        <Route
          exact
          path="/home"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Landing />
            </Suspense>
          }
        />
        <Route
          exact
          path="/notifications"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Notifications />
            </Suspense>
          }
        />

        <Route
          path="/searchResults"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <SearchResults />
            </Suspense>
          }
        />

        <Route
          path="/expiredItems"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <SearchResults />
            </Suspense>
          }
        />
        <Route
          path="/newItems"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <SearchResults />
            </Suspense>
          }
        />

        <Route
          exact
          path="/itemDetail/:itemId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ItemDetailComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/templateDetail/:itemId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <TemplateDetail />
            </Suspense>
          }
        />
        <Route
          exact
          path="/emailDetail/:itemId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <EmailDetail />
            </Suspense>
          }
        />

        <Route
          path="/marketing-material/:marketingMaterialId"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <MarketingMaterial />
            </Suspense>
          }
        />

        {/* for customization of template */}
        <Route
          path="/customize-template/:templateId"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CustomizeTemplatesComp />
            </Suspense>
          }
        />

        {/* for template test preview */}
        <Route
          path="/customize-template/:test/:templateId"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CustomizeTestTemplatesComp />
            </Suspense>
          }
        />

        {/* for admin setup of template */}
        <Route
          path="/TemplateSetup"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <TemplateSetup />
            </Suspense>
          }
        />
        <Route
          path="/manageStateShipWith"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ManageStateShipWith />
            </Suspense>
          }
        />
        <Route
          path="/checkout"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CheckOutComp />
            </Suspense>
          }
        />
        <Route
          path="/e-checkout"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ECheckOut />
            </Suspense>
          }
        />

        <Route
          exact
          path="/orderDetail"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <OrderDetailComp />
            </Suspense>
          }
        />

        <Route
          path="/confirmEmail"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ConfirmEmail />
            </Suspense>
          }
        />
        <Route
          path="/confirmPassword"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ConfirmPassword />
            </Suspense>
          }
        />

        <Route
          exact
          path="/cart"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Cart />
            </Suspense>
          }
        />

        <Route
          path="/passwordChangeSuccessful"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <PasswordChangeSuccessful />
            </Suspense>
          }
        />
        <Route
          exact
          path="/collection"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CollectionComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/createcollection"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CreateCollectionComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/collection/:collectionName/:collectionId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ModifyCollectionComp />
            </Suspense>
          }
        />

        <Route
          exact
          path="/userProfile"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UserProfile />
            </Suspense>
          }
        />
        <Route
          exact
          path="/account/salesTeam&Maintenance"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <SalesTeam />
            </Suspense>
          }
        />
        <Route
          exact
          path="/account/attributeSalesTeam&Maintenance"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AttributeSalesTeam />
            </Suspense>
          }
        />
        <Route
          exact
          path="/ordersearch"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <OrderSearch />
            </Suspense>
          }
        />

        <Route
          path="/userroles"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AllUserRoles />
            </Suspense>
          }
        />
        <Route
          exact
          path="/userroledetail/:roleId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UserDetail />
            </Suspense>
          }
        />
        <Route
          exact
          path="/createuserrole"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UserRoleCreate />
            </Suspense>
          }
        />
        <Route
          exact
          path="/account"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Account />
            </Suspense>
          }
        />
        <Route
          path="/support"
          exact
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Support />
            </Suspense>
          }
        />
        <Route
          exact
          path="/shippingtype"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ShippingTypeComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/userSearch"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UserSearch />
            </Suspense>
          }
        />
        <Route
          exact
          path="/validForUse"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ValidForUse />
            </Suspense>
          }
        />
        <Route
          exact
          path="/adminUserSearch"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UserSearch />
            </Suspense>
          }
        />
        <Route
          exact
          path="/createUser"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CreateUser />
            </Suspense>
          }
        />
        <Route
          exact
          path="/emailManagement"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <EmailManagement />
            </Suspense>
          }
        />
        <Route
          exact
          path="/userDetails/:userId"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CreateUser />
            </Suspense>
          }
        />
        <Route
          exact
          path="/orderDetailData/:orderNumber"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <OrderDetailInfoComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/shiptohcp"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ShipToHcpComp />
            </Suspense>
          }
        />
         <Route
          exact
          path="/hcpcustomfeature"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <HcpCustomComp />
            </Suspense>
          }
        /> 
        <Route
          exact
          path="/shiptodistribution"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ShipToDistributionComp />
            </Suspense>
          }
        />
        <Route
          exact
          path="/productDisplay"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ProductDisplay />
            </Suspense>
          }
        />
        <Route
          exact
          path="/siteAdministration"
          element={
            <GuardedRoute
              userPrivilege={userPrivilege}
              requirePrvilage={"SiteAdministration"}
              authFailPath={"/account"}
            />
          }
        >
          <Route
            exact
            path="/siteAdministration"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <SiteAdministration />
              </Suspense>
            }
          />
        </Route>
        <Route
          exact
          path="/addressbook"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AddressBook />
            </Suspense>
          }
        />
        <Route
          exact
          path="/createAddress"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AddressBookCreateEditComp mode="create" />
            </Suspense>
          }
        />
        <Route
          exact
          path="/editAddress/:id"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AddressBookCreateEditComp mode="edit" />
            </Suspense>
          }
        />

        <Route
          exact
          path="/errorDetails"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ErrorDetail />
            </Suspense>
          }
        />

        {/* redirect to login if route not found */}

        <Route
          exact
          path="/account/shipMethodAssignment"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ShippingMethodsAssignment />
            </Suspense>
          }
        />

        <Route
          exact
          path="/logout"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <SessionLogout />
            </Suspense>
          }
        />

        <Route
          exact
          path="/viewAllTemplates"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ViewAllTemplates />
            </Suspense>
          }
        />

        <Route
          exact
          path="/unsubscribeEmail/:companyNo/:email/:status/:token"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UnsubscribeEmail />
            </Suspense>
          }
        />
        <Route
          exact
          path="/personalizeMessageOption"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <PersonalizeMessageOptionComp />
              </Suspense>
            }
            />

        <Route
          exact
          path="/siteAdministration/AddNewMessage"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AddNewMessage />
            </Suspense>
          }
        />
        <Route
          exact
          path="/siteAdministration/editMessage/:id"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AddNewMessage />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  );
};

export default MainApp;
